module.exports = __webpack_public_path__ + "static/media/discord-logo.27a9b5e6.png";